import React, {useRef} from "react";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import WaveLayout from "../src/layouts/WaweLayout";
import CareerHeroAreaContent from "../src/components/subpageHeroArea/CareerHeroAreaContent";
import SubpageHeroArea from "../src/components/subpageHeroArea/SubpageHeroArea";
import styled from "styled-components";
import {deviceMax} from "../styles/device";
import CareerContentComp from "../src/components/careerContent/CareerContentComp";
import Colors from "../src/constants/Colors";
import Image from "next/image";

const Kariyer = () => {


    return (
        <React.Fragment>
            <HtmlHead
                pageTitle={'Kariyer | Pembe Panjur'}
                description={'Pembe Panjur kariyer sayfası ile ilgili detaylara sayfamızdan ulaşabilirsiniz.'}
            />

            <WaveLayout
                bodyBackgroundColor={false}
                backgroundColor={'linear-gradient(180deg, #D2147D 0%, #752280 100%)'}
                loginButtonText={false}
                hamburgerMenuType={'white'}
                backgroundType={'linear'}
                sloganOne={''}
                sloganTwo={''}
                homeButton={true}
                className={'career_page'}
                extraChildren={
                    <React.Fragment>
                        <CareerContainer>
                            <CareerContentComp/>
                        </CareerContainer>
                    </React.Fragment>
                }
            >
                <SubpageHeroArea career={false}>
                    <CareerHeroAreaContent />
                    {/*<ViewPositionsButton backgroundColor={'#fff'} textColor={false}/>*/}
                    <div className={'career-desktop-img'}>
                        <Image loading={'lazy'} width={1392}
                               height={1140}
                               sizes={'100vw'}
                               style={{width: '100%', height: 'auto'}}
                               src={`/next/assets/images/career/career-hero-area.png`}
                               alt={'Pembe Panjur Kariyer'} title={'Pembe Panjur Kariyer'}
                        />
                    </div>
                </SubpageHeroArea>

            </WaveLayout>
        </React.Fragment>
    )
}

const CareerContainer = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 47px calc(50vw - 575px) 28px;

  background: rgba(0, 0, 0, 0.04);

  @media ${deviceMax.tablet} {
    padding-top: 32px;
    background: ${Colors.white};
  }
`;

import { checkAuthAndRedirect } from '../src/utils/authHelper';
export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};

export default Kariyer;
